/**
 * Opens a WebSocket that automatically reconnects with exponential backoff.
 * Returns a cleanup function that permanently closes the connection.
 */
export function connectWs(
  url: string,
  onMessage: (event: MessageEvent) => void,
): () => void {
  let ws: WebSocket | null = null
  let attempt = 0
  let timer: ReturnType<typeof setTimeout> | null = null
  let stopped = false

  function open() {
    if (stopped) return
    ws = new WebSocket(url)
    ws.addEventListener("message", onMessage)
    ws.addEventListener("open", () => {
      attempt = 0
    })
    ws.addEventListener("close", () => {
      if (stopped) return
      const delay = Math.min(1000 * 2 ** attempt, 30_000)
      attempt++
      timer = setTimeout(open, delay)
    })
  }

  open()

  return () => {
    stopped = true
    if (timer) clearTimeout(timer)
    ws?.close()
  }
}
